export const setOrderTotalsTitles = value => ({
    type: 'SET_ORDER_TOTALS_TITLES',
    value
});

export const setShowTaxesAfterTotal = value => ({
    type: 'SET_SHOW_TAXES_AFTER_TOTAL',
    value
});
